// extracted by mini-css-extract-plugin
export default {"container":"Info__container___IrtYu"};